<template>
   <!-- create container covering all screen -->
   <div id='mapid' class='mainmap h-screen w-screen'></div>
   <div class="cursor rounded"></div>
   <!--  -->
   <div class="map-overlay top">
      <div class="map-overlay-inner">
         <fieldset>
            <div class="tab">
               <button id="Fct_btn" class="tablinks">Données de base</button>
               <button id="Agreg_btn" class="tablinks">Agrégation spatiale</button>
               <button id="Multifct_btn" class="tablinks">Pondération</button>

            </div>

            <!-- Tab content -->
            <div id="Fct_tab" class="tabcontent">

               <button @click="isOpen = !isOpen">Ajouter des données annexes</button>

               <div v-show="isOpen">
                  <label>
                     <input id="communes_btn" class="cb_data" type="checkbox">
                     Contours des communes
                  </label>
                  <br>
                  <label>
                     <input id="reseau_routier_btn" class="cb_data" type="checkbox">
                     Réseau routier
                  </label>
                  <br>
                  <label>
                     <input id="reseau_hydro_btn" class="cb_data" type="checkbox">
                     Cours d'eau
                  </label>
                  <br>
                  <label>
                     <input id="parcelles_btn" class="cb_data" type="checkbox">
                     Parcelles
                  </label>
                  <br>
                  <label>
                     <input id="tache_urbaine_btn" class="cb_data" type="checkbox">
                     Tache urbaine
                  </label>
                  <br>
               </div>
               <br>
               <br>
               <label> Sélectionnez la fonction à afficher :</label>
               <form>
                  <label>
                     <input id="fct1_btn" class="cb_fct" type="checkbox">
                     Production de biomasse végétale
                  </label>
                  <div id="legend1" class="legend" style="visibility: hidden;">
                     <label>
                        Score de réalisation de fonction :
                     </label>
                  </div>
                  <input id="unc1_btn" class="cb_fct" type="checkbox">
                  Carte d'incertitude associée
                  <br>
                  <label>
                     <input id="fct2_btn" class="cb_fct" type="checkbox">
                     Infiltration et épuration de l'eau
                  </label>
                  <div id="legend2" class="legend" style="visibility: hidden;">
                     <label>
                        Score de réalisation de fonction :
                     </label>
                  </div>
                  <input id="unc2_btn" class="cb_fct" type="checkbox">
                  Carte d'incertitude associée
                  <br>
                  <label>
                     <input id="fct3_btn" class="cb_fct" type="checkbox">
                     Stockage de carbone
                  </label>
                  <div id="legend3" class="legend" style="visibility: hidden;">
                     <label>
                        Score de réalisation de fonction :
                     </label>
                  </div>
                  <input id="unc3_btn" class="cb_fct" type="checkbox">
                  Carte d'incertitude associée
                  <div id="legend_unc" class="legend" style="visibility: hidden;">
                     <br>
                     <br>
                     <label>
                        Échelle d'incertitude :
                     </label>
                  </div>
               </form>
            </div>

            <div id="Agreg_tab" class="tabcontent">

               <label> Choisissez le niveau d'agrégation de la carte de multifonctionnalité :</label>
               <br>

               <input type="radio" id="level0" name="agreg" v-model="agregLevel" value="0">
               <label for="age1">0 - Carte non agrégée</label><br>
               <input type="radio" id="level1" name="agreg" v-model="agregLevel" value="1">
               <label for="age1">1 - Carte légérement agrégée</label><br>
               <input type="radio" id="level2" name="agreg" v-model="agregLevel" value="2">
               <label for="age1">2 - Carte "optimum théorique"</label><br>
               <input type="radio" id="level3" name="agreg" v-model="agregLevel" value="3">
               <label for="age1">3 - Carte très agrégée</label><br>


               <br>
               <br>

               <button @click="isOpen = !isOpen">Ajouter des données annexes</button>

               <div v-show="isOpen">
                  <label>
                     <input id="communes_btn2" class="cb_data" type="checkbox">
                     Contours des communes
                  </label>
                  <br>
                  <label>
                     <input id="reseau_routier_btn2" class="cb_data" type="checkbox">
                     Réseau routier
                  </label>
                  <br>
                  <label>
                     <input id="reseau_hydro_btn2" class="cb_data" type="checkbox">
                     Cours d'eau
                  </label>
                  <br>
                  <label>
                     <input id="parcelles_btn2" class="cb_data" type="checkbox">
                     Parcelles
                  </label>
                  <br>
                  <label>
                     <input id="tache_urbaine_btn2" class="cb_data" type="checkbox">
                     Tache urbaine
                  </label>
                  <br>
               </div>
               <br>
               <br>
               <button id="displayMultif" type="button" style="font: bold 14px Arial;">Multifonctionnalité</button>
               <br>
               <div id="legend_multif2" class="legend" style="visibility: hidden;"></div>
               <br>
               <br>
               <button id="displayMultifUnc" type="button" style="font: bold 14px Arial;">Incertitude</button>
               <br>
               <div id="legend_unc2" class="legend" style="visibility: hidden;"></div>
               <br>
               <br>
               <button id="removeMaps" type="button" style="font: bold 14px Arial;">Nettoyer</button>
               <br>
               <form>
                  <br>
                  <div id="legend_unc" class="legend" style="visibility: hidden;">
                     <br>
                     <br>
                     <label>
                        Échelle d'incertitude :
                     </label>
                  </div>
               </form>
            </div>


            <div id="Multifct_tab" class="tabcontent">
               <h3>Obtention d'une carte de multifonctionnalité : </h3>
               <label>Déplacez le curseur pour indiquer les importances relatives des fonctions aux extrémités (curseur
                  au milieu :
                  importance égale; curseur tout à gauche : fonction de gauche bien plus importante) : </label>
               <br>
               <br>
               <span>Infiltration &nbsp;</span>
               <input type="range" class="range-input" min="0" max="4" id="slider1" list="ticks" v-model="PvsI_cursor">
               <span>Production</span>
               <br>
               <br>
               <span>Stockage C</span>
               <input type="range" class="range-input" min="0" max="4" id="slider2" list="ticks" v-model="IvsS_cursor">
               <span>Infiltration</span>
               <br>
               <br>
               <span>Production &nbsp;</span>
               <input type="range" class="range-input" min="0" max="4" id="slider3" list="ticks" v-model="SvsP_cursor">
               <span>Stockage C</span>
               <br>
               <br>
               <button id="runAHP" type="button" style="font: bold 14px Arial;">Valider les préférences</button>
               <br>
               <br>
               <div id="legend_multif" class="legend" style="visibility: hidden;">
                  <label>
                     Score de multifonctionnalité :
                  </label>
               </div>
               <br>
               <br>
               <span> La carte affichée correspond à une prise en compte :</span>
               <br>
               <span>- de la fonction production à hauteur de {{ percent_prod }} %</span>
               <br>
               <span>- de la fonction infiltration à hauteur de {{ percent_infilt }} %</span>
               <br>
               <span>- de la fonction stockage à hauteur de {{ percent_stock }} %</span>
               <br>
               <!-- <input id="unc_multif_btn" class="cb_fct" type="checkbox">
               Carte d'incertitude associée -->
               <div id="legend_unc_multif" class="legend" style="visibility: hidden;">
                  <label>
                     Score de multifonctionnalité :
                  </label>
               </div>
            </div>
         </fieldset>
      </div>
   </div>
   <!-- <nav id="menu"></nav> -->
</template>

<script>
import mapboxgl from 'mapbox-gl'; // loads mapbox library
import AHP from 'ahp';
import { onMounted } from 'vue';

export default {
   name: 'ReliefMap',
   data() {
      return {
         isOpen: false,
         PvsI_cursor: 2,
         IvsS_cursor: 2,
         SvsP_cursor: 2,
         PvsI: 1,
         IvsS: 1,
         SvsP: 1,
         percent_prod: 33,
         percent_infilt: 33,
         percent_stock: 33,
         agregLevel: 0,
         values: [1 / 7, 1 / 5, 1, 5, 7],
         
         // url of rendered raster maps
         url_rasters: new Object({
            "PROD_mean": ["laco504.ug4xwc"],
            "PROD_std": ["laco504.talkg8"],
            "WATER_mean": ["laco504.olygux"],
            "WATER_std": ["laco504.op48rf"],
            "CLIM_mean": ["laco504.444tga"],
            "CLIM_std": ["laco504.a2c518"],
            "Multif_mean": ["laco504.54f795"],
            "Multif_std": ["laco504.w8w3r8"],
         }),
         
         // url of aggregated Multif and Uncertainty maps
         url_vectors: new Object({
            "1": ["avignon_1.zip-dig6ie", "laco504.3nzf7s"],
            "2": ["avignon_2.zip-b0b3g7", "laco504.ur7pxm"],
            "3": ["avignon_3.zip-evjocg", "laco504.mpkg90"],
         }),

         // url of weighted maps
         url_dict_weights: new Object({
            "5_25_70": ["avignon_5_25_70.zip-5dd191", "laco504.s4v7za"],
            "5_30_65": ["avignon_5_30_65.zip-wycsag", "laco504.6cunq1"],
            "5_70_25": ["avignon_5_70_25.zip-isi9aw", "laco504.yjb5lg"],
            "5_75_20": ["avignon_5_75_20.zip-lf0nqc", "laco504.h99oru"],
            "10_15_75": ["avignon_10_15_75.zip-lemvuj", "laco504.e2be8r"],
            "10_20_70": ["avignon_10_20_70.zip-ftpf9j", "laco504.nv1bi2"],
            "10_25_65": ["avignon_10_25_65.zip-n90dw4", "laco504.zuyndm"],
            "10_40_50": ["avignon_10_40_50.zip-dvir63", "laco504.r9ms35"],
            "10_45_45": ["avignon_10_45_45.zip-of639t", "laco504.s8ukxb"],
            "10_65_25": ["avignon_10_65_25.zip-k6vpec", "laco504.v9gezd"],
            "10_70_20": ["avignon_10_70_20.zip-1bylcq", "laco504.bwv2ru"],
            "10_80_10": ["avignon_10_80_10.zip-dxhmhp", "laco504.tp6fom"],
            "15_10_75": ["avignon_15_10_75.zip-hac33f", "laco504.4xa45c"],
            "15_15_70": ["avignon_15_15_70.zip-gpnd00", "laco504.8hxoxi"],
            "15_35_50": ["avignon_15_35_50.zip-91hs9f", "laco504.uq2i4d"],
            "15_55_30": ["avignon_15_55_30.zip-3o5wc7", "laco504.6vxzed"],
            "15_70_15": ["avignon_15_70_15.zip-ol5hee", "laco504.6bu9kn"],
            "15_75_10": ["avignon_15_75_10.zip-l8c49n", "laco504.pow2mi"],
            "20_5_75": ["avignon_20_5_75.zip-8f6nba", "laco504.4yuri2"],
            "20_30_50": ["avignon_20_30_50.zip-eh87k1", "laco504.pweuqu"],
            "20_35_45": ["avignon_20_35_45.zip-nnjwka", "laco504.68oi5o"],
            "20_45_35": ["avignon_20_45_35.zip-gup96w", "laco504.rci4uw"],
            "20_50_30": ["avignon_20_50_30.zip-ugnoz2", "laco504.f2djbl"],
            "20_70_10": ["avignon_20_70_10.zip-hq4uxg", "laco504.zf353u"],
            "25_5_70": ["avignon_25_5_70.zip-xwb3ne", "laco504.q5ano5"],
            "25_10_65": ["avignon_25_10_65.zip-va16uv", "laco504.f2jmz7"],
            "25_65_10": ["avignon_25_65_10.zip-0fizi3", "laco504.f3w7p7"],
            "25_70_5": ["avignon_25_70_5.zip-yvhnfh", "laco504.pdaydt"],
            "30_15_55": ["avignon_30_15_55.zip-s76fpx", "laco504.255c42"],
            "30_20_50": ["avignon_30_20_50.zip-brt7cr", "laco504.9vztzd"],
            "30_25_45": ["avignon_30_25_45.zip-uz4ni7", "laco504.guphlj"],
            "30_45_25": ["avignon_30_45_25.zip-pek9c0", "laco504.t04pdv"],
            "30_50_20": ["avignon_30_50_20.zip-u9hvf6", "laco504.v9wutc"],
            "30_55_15": ["avignon_30_55_15.zip-1dtb7o", "laco504.l1jefe"],
            "30_65_5": ["avignon_30_65_5.zip-0yl6lq", "laco504.h8zsv4"],
            "33_33_33": ["avignon_33_33_33.zip-a7dstf", "laco504.x9j1op"],
            "35_20_45": ["avignon_35_20_45.zip-dzj965", "laco504.9pq4fs"],
            "35_45_20": ["avignon_35_45_20.zip-3uzfbl", "laco504.os3r2o"],
            "45_5_50": ["avignon_45_5_50.zip-ph0fyz", "laco504.63vq0n"],
            "45_10_45": ["avignon_45_10_45.zip-w6f0jc", "laco504.tbow77"],
            "45_25_30": ["avignon_45_25_30.zip-xqo9kc", "laco504.advl4s"],
            "45_35_20": ["avignon_45_35_20.zip-cxgudf", "laco504.il2cf7"],
            "45_50_5": ["avignon_45_50_5.zip-vjfnfw", "laco504.mrtxcq"],
            "50_5_45": ["avignon_50_5_45.zip-9wispy", "laco504.or4vmb"],
            "50_15_35": ["avignon_50_15_35.zip-zl6f0p", "laco504.2b70n8"],
            "50_20_30": ["avignon_50_20_30.zip-g4n7sx", "laco504.366mhx"],
            "50_30_20": ["avignon_50_30_20.zip-0wx05g", "laco504.spfd9a"],
            "50_45_5": ["avignon_50_45_5.zip-r1kkre", "laco504.3cmjiz"],
            "55_15_30": ["avignon_55_15_30.zip-89vlg6", "laco504.wdw6qx"],
            "55_30_15": ["avignon_55_30_15.zip-ngl7mx", "laco504.z8oz2t"],
            "65_10_25": ["avignon_65_10_25.zip-ptsnkv", "laco504.4r9cyy"],
            "65_25_10": ["avignon_65_25_10.zip-u1s1uh", "laco504.9bp4gw"],
            "65_30_5": ["avignon_65_30_5.zip-si23bu", "laco504.8adkf8"],
            "70_5_25": ["avignon_70_5_25.zip-al7gas", "laco504.rmhucq"],
            "70_10_20": ["avignon_70_10_20.zip-uef88t", "laco504.8b0pmq"],
            "70_20_10": ["avignon_70_20_10.zip-e6a282", "laco504.rbwvpc"],
            "70_25_5": ["avignon_70_25_5.zip-864xj7", "laco504.i8ggtx"],
            "75_5_20": ["avignon_75_5_20.zip-wml97w", "laco504.am6a7n"],
            "75_10_15": ["avignon_75_10_15.zip-91y8rc", "laco504.yszqdb"],
            "75_20_5": ["avignon_75_20_5.zip-k1if64", "laco504.1o9jga"],
            "80_10_10": ["avignon_80_10_10.zip-mf05jo", "laco504.flp1qx"]
         })
      };
   },
   watch: {
      isVisible(newVal) {
         if (newVal) {
            this.$nextTick(() => {
               this.$refs.myCheckbox.addEventListener('change', this.handleChange);
            });
         }
      }
   },
   methods: {
      showTab(evt, tab) {
         // console.log(evt);
         // Declare all variables
         var i, tabcontent, tablinks;

         // Get all elements with class="tabcontent" and hide them
         tabcontent = document.getElementsByClassName("tabcontent");
         for (i = 0; i < tabcontent.length; i++) {
            // console.log("ok");
            tabcontent[i].style.display = "none"; // hide tabcontent[i]
         }

         // Get all elements with class="tablinks" and remove the class "active"
         tablinks = document.getElementsByClassName("tablinks");
         for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
         }

         // Show the current tab, and add an "active" class to the button that opened the tab
         evt.currentTarget.style.display = "block";
         document.getElementById(tab).style.display = "block";
         evt.currentTarget.className += " active";
      },
      cbChange_fct() {
         // Remove all legends
         var legendsToHide = document.getElementsByClassName("legend");
         console.log(legendsToHide);
         for (var j = 0; j < legendsToHide.length; j++) {
            console.log(j);
            legendsToHide[j].style.visibility = 'hidden'; // depending on what you're doing
            // legendsToHide[j].remove();
         }
      },

      createLegendFct(l, col) {
         console.log("ok");
         const legendElement = document.getElementById(l);
         // if (legendElement.children.length > 0) return;

         // const layers = ['Fonction non remplie', 'Fonction remplie'];
         const layers = ['1 - Très faible', '2 - Faible', '3 - Moyen', '4 - Fort', '5 - Très fort'];
         const colors = col;

         for (let i = 0; i < layers.length; i++) {
            var layer = layers[i];
            var color = colors[i];
            var item = document.createElement('div');
            var key = document.createElement('span');
            key.className = 'legend-key';
            key.style.backgroundColor = color;
            key.style.color = color;
            // key.style.width = '5px';
            // key.style.height = '5px';
            // item.style.backgroundColor = color;

            var value = document.createElement('span');
            value.innerHTML = layer;
            item.appendChild(key);
            item.appendChild(value);
            legendElement.appendChild(item);
         }
      },

      createLegendUncFct(l) {
         console.log("ok");
         const legendElement = document.getElementById(l);
         // if (legendElement.children.length > 0) return;

         // const layers = ['Fonction non remplie', 'Fonction remplie'];
         const layers = ["+/- 0", "+/- 1", "+/- 2", "+/- 3"];
         const colors = [
            "#fafafa",
            "#a8a8a8",
            "#575757",
            "#050505"
         ];

         for (let i = 0; i < layers.length; i++) {
            var layer = layers[i];
            var color = colors[i];
            var item = document.createElement('div');
            var key = document.createElement('span');
            key.className = 'legend-key';
            key.style.backgroundColor = color;
            key.style.color = color;
            // key.style.width = '5px';
            // key.style.height = '5px';
            // item.style.backgroundColor = color;

            var value = document.createElement('span');
            value.innerHTML = layer;
            item.appendChild(key);
            item.appendChild(value);
            legendElement.appendChild(item);
         }
      },

      createLegendUncMultif(l) {
         console.log("ok");
         const legendElement = document.getElementById(l);
         // if (legendElement.children.length > 0) return;

         // const layers = ['Fonction non remplie', 'Fonction remplie'];
         const layers = ["+/- 1", "+/- 2", "+/- 3", "+/- 4"];
         const colors = [
            "#fafafa",
            "#a8a8a8",
            "#575757",
            "#050505"
         ];

         for (let i = 0; i < layers.length; i++) {
            var layer = layers[i];
            var color = colors[i];
            var item = document.createElement('div');
            var key = document.createElement('span');
            key.className = 'legend-key';
            key.style.backgroundColor = color;
            key.style.color = color;
            // key.style.width = '5px';
            // key.style.height = '5px';
            // item.style.backgroundColor = color;

            var value = document.createElement('span');
            value.innerHTML = layer;
            item.appendChild(key);
            item.appendChild(value);
            legendElement.appendChild(item);
         }
      },

      createLegendMultif(l) {
         console.log("ok");
         const legendElement = document.getElementById(l);
         // if (legendElement.children.length > 0) return;

         // const layers = ['Fonction non remplie', 'Fonction remplie'];
         const layers = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
         const colors = [
            // "rgb(0,0,0, 0)",
            // "rgb(0,0,0, 0)",
            // "rgb(0,0,0, 0)",
            // "rgb(0,0,0, 0)",
            // "rgb(0,0,0, 0)",
            "rgb(158, 1, 66)",
            "rgb(213, 62, 79)",
            "rgb(244, 109, 67)",
            "rgb(253, 174, 97)",
            "rgb(254, 224, 139)",
            "rgb(255, 255, 191)",
            "rgb(230, 245, 152)",
            "rgb(171, 221, 164)",
            "rgb(102, 194, 165)",
            "rgb(50, 136, 189)",
            "rgb(94, 79, 162)"
         ];

         const class_dict = {
            0: "Multifonctionnalité moyenne",
            4: "Multifonctionnalité forte",
            7: "Multifonctionnalité très forte",
         };
         const milestones = Object.keys(class_dict);
         console.log(milestones);

         for (let i = 0; i < layers.length; i++) {

            console.log(i);
            if (milestones.includes(String(i))) {
               const hr = document.createElement("hr");
               legendElement.appendChild(hr);

               const textNode = document.createTextNode(class_dict[String(i)]);
               const div = document.createElement("div");
               div.appendChild(textNode);
               div.style.textAlign = "center";

               legendElement.appendChild(div);
            }

            var layer = layers[i];
            var color = colors[i];
            var item = document.createElement('div');
            var key = document.createElement('span');
            key.className = 'legend-key';
            key.style.backgroundColor = color;
            key.style.color = color;
            // key.style.width = '5px';
            // key.style.height = '5px';
            // item.style.backgroundColor = color;

            var value = document.createElement('span');
            value.innerHTML = layer;
            item.appendChild(key);
            item.appendChild(value);
            legendElement.appendChild(item);

         }
      },

      displayFct1(evt) {

         this.currentMap = "PROD";

         // Switch buttons
         this.cbChange_fct(evt);
         document.getElementById("fct2_btn").checked = false;
         document.getElementById("fct3_btn").checked = false;

         console.log(evt.currentTarget.checked);

         if (evt.currentTarget.checked == true) {
            // Add legend

            const legendElement = document.getElementById("legend1");
            legendElement.style.visibility = 'visible';


            // Add layer
            this.map.addSource('PROD_source', {
               type: "raster",
               url: "mapbox://" + this.url_rasters["PROD_mean"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'PROD_layer',
               type: 'raster',
               source: 'PROD_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.removeLayer("PROD_layer");
            this.map.removeSource("PROD_source");
         }

      },

      displayFct2(evt) {

         this.currentMap = "WATER";

         // Switch buttons
         this.cbChange_fct(evt);
         document.getElementById("fct1_btn").checked = false;
         document.getElementById("fct3_btn").checked = false;

         if (evt.currentTarget.checked == true) {
            // Add legend
            const legendElement = document.getElementById("legend2");
            legendElement.style.visibility = 'visible';

            // Add layer
            this.map.addSource('WATER_source', {
               type: "raster",
               url: "mapbox://" + this.url_rasters["WATER_mean"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'WATER_layer',
               type: 'raster',
               source: 'WATER_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.removeLayer("WATER_layer");
            this.map.removeSource("WATER_source");
         }
      },

      displayFct3(evt) {

         this.currentMap = "CLIM";

         // Switch buttons
         this.cbChange_fct(evt);

         document.getElementById("fct1_btn").checked = false;
         document.getElementById("fct2_btn").checked = false;

         if (evt.currentTarget.checked == true) {
            // Add legend
            const legendElement = document.getElementById("legend3");
            legendElement.style.visibility = 'visible';

            // Add layer
            this.map.addSource('CLIM_source', {
               type: "raster",
               url: "mapbox://" + this.url_rasters["CLIM_mean"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'CLIM_layer',
               type: 'raster',
               source: 'CLIM_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.removeLayer("CLIM_layer");
            this.map.removeSource("CLIM_source");
         }
      },

      displayUnc1(evt) {
         // Switch buttons
         this.cbChange_fct(evt);
         document.getElementById("unc2_btn").checked = false;
         document.getElementById("unc3_btn").checked = false;

         console.log(evt.currentTarget.checked);

         if (evt.currentTarget.checked == true) {
            // Add legend

            const legendElement = document.getElementById("legend_unc");
            legendElement.style.visibility = 'visible';


            // Add layer
            this.map.addSource('PROD_unc_source', {
               type: "raster",
               url: "mapbox://" + this.url_rasters["PROD_std"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'PROD_unc_layer',
               type: 'raster',
               source: 'PROD_unc_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.removeLayer("PROD_unc_layer");
            this.map.removeSource("PROD_unc_source");
         }

      },

      displayUnc2(evt) {
         // Switch buttons
         this.cbChange_fct(evt);
         document.getElementById("unc1_btn").checked = false;
         document.getElementById("unc3_btn").checked = false;

         if (evt.currentTarget.checked == true) {
            // Add legend
            const legendElement = document.getElementById("legend_unc");
            legendElement.style.visibility = 'visible';

            // Add layer
            this.map.addSource('WATER_unc_source', {
               type: "raster",
               url: "mapbox://" + this.url_rasters["WATER_std"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'WATER_unc_layer',
               type: 'raster',
               source: 'WATER_unc_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.removeLayer("WATER_unc_layer");
            this.map.removeSource("WATER_unc_source");
         }
      },

      displayUnc3(evt) {
         // Switch buttons
         this.cbChange_fct(evt);

         document.getElementById("unc1_btn").checked = false;
         document.getElementById("unc2_btn").checked = false;

         if (evt.currentTarget.checked == true) {
            // Add legend
            const legendElement = document.getElementById("legend_unc");
            legendElement.style.visibility = 'visible';

            // Add layer
            this.map.addSource('CLIM_unc_source', {
               type: "raster",
               url: "mapbox://" + this.url_rasters["CLIM_std"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'CLIM_unc_layer',
               type: 'raster',
               source: 'CLIM_unc_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.removeLayer("CLIM_unc_layer");
            this.map.removeSource("CLIM_unc_source");
         }
      },

      displayUncWeighted() {
         this.cleanMap();

         const legendElement = document.getElementById("legend_unc_multif");
         legendElement.style.visibility = 'visible';

         this.map.addSource("MultifUnc_source", {
            type: "raster",
            url: "mapbox://" + this.url_rasters["AUAT_std"],
            tileSize: 512
         });
         this.map.addLayer({
            id: 'MultifUnc_layer',
            type: 'raster',
            source: 'MultifUnc_source',
            paint: {
               'raster-opacity': 1
            }
         });
      },

      displayUncMultif() {

         this.cleanMap();

         const legendElement = document.getElementById("legend_unc2");
         legendElement.style.visibility = 'visible';

         if (this.agregLevel == 0) {
            this.map.addSource("MultifUnc_source", {
               type: "raster",
               url: "mapbox://" + this.url_rasters["Multif_std"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'MultifUnc_layer',
               type: 'raster',
               source: 'MultifUnc_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.addSource('MultifUnc_source', {
               type: "vector",
               url: "mapbox://" + this.url_vectors[this.agregLevel][1],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'MultifUnc_layer',
               type: 'fill',
               source: 'MultifUnc_source',
               'source-layer': this.url_vectors[this.agregLevel][0],
               paint: {
                  'fill-color': [
                     'step', // the color follows a several-step scale
                     ['get', 'erreur'], // the 'feature-state' is determined by the 'soiltype' attribute
                     '#f7f7f7', 0.4,
                     '#cccccc', 1, // those with soiltype < 2.5 (i.e. == 2) are displayed in green
                     '#969696', 1.5,
                     '#525252', 2,
                     '#2b83ba' // else, (i.e. == 10, the initialized value) they are displayed in grey
                  ],
                  'fill-opacity': 1,
                  // 'fill-outline-color': '#3b3b3b'
               }
            });

            // add popups

            const popup = new mapboxgl.Popup({
               closeButton: false,
               closeOnClick: false
            });

            this.map.on('click', 'MultifUnc_layer', (e) => {
               this.map.getCanvas().style.cursor = 'pointer';

               var multif = e.features[0].properties.multif;
               multif = Math.round(multif * 10) / 10
               var erreur = e.features[0].properties.erreur;
               erreur = Math.round(3 * erreur * 10) / 10
               // const erreur = e.features[0].properties.mn_qs_v;

               const description = 'Multifonctionnalité : ' + multif + "\n" + "Marge d'erreur : " + erreur;

               popup
                  .setLngLat(e.lngLat)
                  .setHTML(description)
                  .addTo(this.map);
            });

            this.map.on('mouseleave', 'MultifUnc_layer', () => {
               this.map.getCanvas().style.cursor = '';
               popup.remove();
            });

         }

      },

      cleanMap() {

         if (this.map.getLayer("Multif_layer")) {
            this.map.removeLayer("Multif_layer");
         }
         if (this.map.getSource("Multif_source")) {
            this.map.removeSource("Multif_source");
         }

         if (this.map.getLayer("MultifUnc_layer")) {
            this.map.removeLayer("MultifUnc_layer");
         }
         if (this.map.getSource("MultifUnc_source")) {
            this.map.removeSource("MultifUnc_source");
         }

         const myLayers = Object.keys(this.url_dict_weights).map(i => i + '_layer');
         const mySources = Object.keys(this.url_dict_weights).map(i => i + '_source');

         // Remove all layers
         myLayers.forEach(id => {
            console.log(id);
            if (this.map.getLayer(id)) this.map.removeLayer(id);
         });
         // Remove all sources
         mySources.forEach(id => {
            if (this.map.getSource(id)) this.map.removeSource(id);
         });
      },

      displayMultifctMap() {

         this.currentMap = "MULTIF";

         this.cleanMap();

         if (this.agregLevel == 0) {
            this.map.addSource("Multif_source", {
               type: "raster",
               url: "mapbox://" + this.url_rasters["Multif_mean"],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'Multif_layer',
               type: 'raster',
               source: 'Multif_source',
               paint: {
                  'raster-opacity': 1
               }
            });
         } else {
            this.map.addSource('Multif_source', {
               type: "vector",
               url: "mapbox://" + this.url_vectors[this.agregLevel][1],
               tileSize: 512
            });
            this.map.addLayer({
               id: 'Multif_layer',
               type: 'fill',
               source: 'Multif_source',
               'source-layer': this.url_vectors[this.agregLevel][0],
               paint: {
                  'fill-color': [
                     'step', // the color follows a several-step scale
                     ['get', 'multif'], // the 'feature-state' is determined by the 'soiltype' attribute
                     '#9e0142', 1.5,
                     '#9e0142', 2.5, // those with soiltype < 2.5 (i.e. == 2) are displayed in green
                     '#9e0142', 3.5,
                     '#9e0142', 4.5,
                     '#9e0142', 5.5,
                     '#d53e4f', 6.5,
                     '#f46d43', 7.5,
                     '#fdae61', 8.5,
                     '#fee08b', 9.5,
                     '#ffffbf', 10.5,
                     '#e6f598', 11.5,
                     '#abdda4', 12.5,
                     '#66c2a5', 13.5,
                     '#3288bd', 14.5,
                     '#5e4fa2', 15.5,
                     '#5e4fa2', 16.5,
                     '#5e4fa2', 17.5,
                     '#5e4fa2', 18.5,
                     '#2b83ba' // else, (i.e. == 10, the initialized value) they are displayed in grey
                  ],
                  'fill-opacity': 1,
                  // 'fill-outline-color': '#3b3b3b'
               }
            });

            // add popups

            const popup = new mapboxgl.Popup({
               closeButton: false,
               closeOnClick: false
            });

            this.map.on('click', 'Multif_layer', (e) => {
               this.map.getCanvas().style.cursor = 'pointer';

               var multif = e.features[0].properties.multif;
               multif = Math.round(multif * 10) / 10
               var erreur = e.features[0].properties.erreur;
               erreur = Math.round(3 * erreur * 10) / 10
               // const erreur = e.features[0].properties.mn_qs_v;

               const description = 'Multifonctionnalité : ' + multif + "\n Marge d'erreur : " + erreur;
               popup
                  .setLngLat(e.lngLat)
                  .setHTML(description)
                  .addTo(this.map);
            });

            this.map.on('mouseleave', 'Multif_layer', () => {
               this.map.getCanvas().style.cursor = '';
               popup.remove();
            });
         }

         const legendElement = document.getElementById("legend_multif2");
         legendElement.style.visibility = 'visible';

         // add popups

         const popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false
         });

         this.map.on('click', 'MultifUnc_layer', (e) => {
            this.map.getCanvas().style.cursor = 'pointer';

            var multif = e.features[0].properties.multif;
            multif = Math.round(multif * 10) / 10
            var erreur = e.features[0].properties.erreur;
            erreur = Math.round(3 * erreur * 10) / 10
            // const erreur = e.features[0].properties.mn_qs_v;

            const description = 'Multifonctionnalité : ' + multif + "\n Marge d'erreur : " + erreur;

            popup
               .setLngLat(e.lngLat)
               .setHTML(description)
               .addTo(this.map);
         });

         this.map.on('mouseleave', 'MultifUnc_layer', () => {
            this.map.getCanvas().style.cursor = '';
            popup.remove();
         });

      },

      displayWeightedMap() {

         this.currentMap = "MULTIF";

         this.cleanMap();
         console.log("OK");
         this.weights = this.percent_prod + '_' + this.percent_infilt + '_' + this.percent_stock;

         this.map.addSource('Multif_source', {
            type: "vector",
            url: "mapbox://" + this.url_dict_weights[this.weights][1],
            tileSize: 512
         });
         this.map.addLayer({
            id: 'Multif_layer',
            type: 'fill',
            source: 'Multif_source',
            'source-layer': this.url_dict_weights[this.weights][0],
            paint: {
               'fill-color': [
                  'step', // the color follows a several-step scale
                  ['get', 'multif'], // the 'feature-state' is determined by the 'soiltype' attribute
                  '#9e0142', 0.5,
                  '#9e0142', 0.83, // those with soiltype < 2.5 (i.e. == 2) are displayed in green
                  '#9e0142', 1.17,
                  '#9e0142', 1.5,
                  '#9e0142', 1.83,
                  '#d53e4f', 2.17,
                  '#f46d43', 2.5,
                  '#fdae61', 2.83,
                  '#fee08b', 3.17,
                  '#ffffbf', 3.5,
                  '#e6f598', 3.83,
                  '#abdda4', 4.17,
                  '#66c2a5', 4.5,
                  '#3288bd', 4.83,
                  '#5e4fa2', 5.17,
                  '#5e4fa2', 5.5,
                  '#5e4fa2', 5.83,
                  '#5e4fa2', 6.17,
                  '#2b83ba' // else, (i.e. == 10, the initialized value) they are displayed in grey
               ],
               'fill-opacity': 1,
               // 'fill-outline-color': '#3b3b3b'
            }
         });

         // add popups

         const popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false
         });

         this.map.on('click', 'Multif_layer', (e) => {
            this.map.getCanvas().style.cursor = 'pointer';

            var multif = e.features[0].properties.multif;
            multif = Math.round(3 * multif * 10) / 10
            var erreur = e.features[0].properties.erreur;
            erreur = Math.round(3 * erreur * 10) / 10
            // const erreur = e.features[0].properties.mn_qs_v;

            const description = 'Multifonctionnalité : ' + multif + "\n Marge d'erreur : " + erreur;
            popup
               .setLngLat(e.lngLat)
               .setHTML(description)
               .addTo(this.map);
         });

         this.map.on('mouseleave', 'Multif_layer', () => {
            this.map.getCanvas().style.cursor = '';
            popup.remove();
         });

         const legendElement = document.getElementById("legend_multif");
         legendElement.style.visibility = 'visible';
      },


      show_polygons(evt, _src, _layer, _source_layer, _url, _color) {
         if (evt.currentTarget.checked == true) { // if the checkbox was just checked
            // console.log("add");
            this.map.addSource(_src, {
               type: 'vector',
               url: _url
            });

            this.map.addLayer({
               id: _layer,
               type: 'fill',
               source: _src,
               'source-layer': _source_layer,
               paint: {
                  'fill-color': _color,
                  'fill-opacity': 1,
               }
            });
         } else { // if the checkbox was just unchecked
            // console.log("remove");
            this.map.removeLayer(_layer);
            this.map.removeSource(_src);
         }
      },

      show_lines(evt, _src, _layer, _source_layer, _url, _color, _width) {
         if (evt.currentTarget.checked == true) { // if the checkbox was just checked
            // console.log("add");
            this.map.addSource(_src, {
               type: 'vector',
               url: _url
            });

            this.map.addLayer({
               id: _layer,
               type: 'line',
               source: _src,
               'source-layer': _source_layer,
               paint: {
                  'line-color': _color,
                  // 'fill-opacity': 0.9,
                  'line-width': _width
               }
            });
         } else { // if the checkbox was just unchecked
            // console.log("remove");
            this.map.removeLayer(_layer);
            this.map.removeSource(_src);
         }
      },

      roundPercentage(x) {
         return (Math.round(x * 100))
      },

      largestRemainder(weights) {
         const specialCases = new Set([
            "33_33_33",
            "33_32_35",
            "33_35_32",
            "32_35_33",
            "32_33_35",
            "35_33_32",
            "35_32_33"
         ]);

         if (specialCases.has(weights)) {
            return [33, 33, 33];
         }

         const [weight1, weight2, weight3] = weights.split("_").map(Number);

         const remainders = [
            weight1 % 5,
            weight2 % 5,
            weight3 % 5
         ];

         // Equivalent to rank(-remainders, ties.method = "first")
         const orderOfPriority = remainders
            .map((value, index) => ({ value, index }))
            .sort((a, b) => {
               if (b.value !== a.value) {
                  return b.value - a.value; // descending remainder
               }
               return a.index - b.index; // preserve original order for ties
            })
            .map(item => item.index);

         const quotas = [
            Math.floor(weight1 / 10 * 2) / 2 * 10,
            Math.floor(weight2 / 10 * 2) / 2 * 10,
            Math.floor(weight3 / 10 * 2) / 2 * 10
         ];

         let counter = 0;

         while (quotas.reduce((a, b) => a + b, 0) < 100) {
            quotas[orderOfPriority[counter]] += 5;
            counter++;
         }

         return quotas;
      },

      runAHP() {
         this.PvsI = this.values[this.PvsI_cursor];
         this.IvsS = this.values[this.IvsS_cursor];
         this.SvsP = this.values[this.SvsP_cursor];
         const ahpContext = new AHP();
         ahpContext.addItems(['PROD', 'EAU', 'CARB']);
         ahpContext.addCriteria(['Relevance']);
         ahpContext.rankCriteriaItem('Relevance', [
            ['PROD', 'EAU', this.PvsI],
            ['EAU', 'CARB', this.IvsS],
            ['CARB', 'PROD', this.SvsP],
         ]
         )

         // ahpContext.setCriteriaItemRankByGivenScores('')
         // ahpContext.rankCriteria(
         //    [
         //       []
         //    ]
         // )

         const output = ahpContext.run();
         console.log(output);
         // Round percentages
         this.percent_prod = this.roundPercentage(output.rankedScoreMap['PROD']);
         this.percent_infilt = this.roundPercentage(output.rankedScoreMap['EAU']);
         this.percent_stock = this.roundPercentage(output.rankedScoreMap['CARB']);

         // Get percentages rounded up to 5
         var out = this.largestRemainder(this.percent_prod + '_' + this.percent_infilt + '_' + this.percent_stock);

         this.percent_prod = out[0]
         this.percent_infilt = out[1]
         this.percent_stock = out[2]


         this.displayWeightedMap();

      },

      testAHP() {
         // Useful to get all possible combinations of cursor values
         const rows = [];

         for (let PvsI_cursor = 0; PvsI_cursor < 5; PvsI_cursor++) {
            for (let IvsS_cursor = 0; IvsS_cursor < 5; IvsS_cursor++) {
               for (let SvsP_cursor = 0; SvsP_cursor < 5; SvsP_cursor++) {
                  const PvsI = this.values[PvsI_cursor];
                  const IvsS = this.values[IvsS_cursor];
                  const SvsP = this.values[SvsP_cursor];
                  // console.log(PvsI);
                  // console.log(IvsS);
                  // console.log(SvsP);
                  const ahpContext = new AHP();
                  ahpContext.addItems(['PROD', 'EAU', 'CARB']);
                  ahpContext.addCriteria(['Relevance']);
                  ahpContext.rankCriteriaItem('Relevance', [
                     ['PROD', 'EAU', PvsI],
                     ['EAU', 'CARB', IvsS],
                     ['CARB', 'PROD', SvsP],
                  ]
                  )
                  const output = ahpContext.run();
                  // console.log(output);
                  this.percent_prod = this.roundPercentage(output.rankedScoreMap['PROD']);
                  this.percent_infilt = this.roundPercentage(output.rankedScoreMap['EAU']);
                  this.percent_stock = this.roundPercentage(output.rankedScoreMap['CARB']);

                  var out = this.largestRemainder(this.percent_prod + '_' + this.percent_infilt + '_' + this.percent_stock);

                  this.percent_prod = out[0]
                  this.percent_infilt = out[1]
                  this.percent_stock = out[2]

                  rows.push([PvsI_cursor, IvsS_cursor, SvsP_cursor, this.percent_prod, this.percent_infilt, this.percent_stock]);

               }
            }
         }

         console.log(rows);

         let csvContent = "data:text/csv;charset=utf-8,";

         rows.forEach(function (rowArray) {
            let row = rowArray.join(",");
            csvContent += row + "\r\n";
         });

         var encodedUri = encodeURI(csvContent);
         var link = document.createElement("a");
         link.setAttribute("href", encodedUri);
         link.setAttribute("download", "my_data.csv");
         document.body.appendChild(link); // Required for FF

         link.click(); // This will download the data file named "my_data.csv".


      }
   },

   created() {
      onMounted(() => {
         mapboxgl.accessToken = 'pk.eyJ1IjoibGFjbzUwNCIsImEiOiJjbDZ5dG00N28wc3p0M2lxbXVydTA2MW84In0.pcjx2I2Ves1Eb7YsdDRcBg';

         // add base map
         this.map = new mapboxgl.Map({
            container: 'mapid',
            zoom: 10,
            // center: [3.12761941, 43.45850273], // Soubès 34700
            center: [4.80219, 43.94625],
            style: 'mapbox://styles/mapbox/satellite-streets-v12' // satellite with no place labels
         });

         // add navigation control
         const nav = new mapboxgl.NavigationControl({
            showCompass: true,
            showZoom: true
         });
         this.map.addControl(nav, 'top-left'); // add nav object to the top-left
         // this.map.addControl(nav, 'top-left'); // add nav object to the top-left


         document.getElementById('Fct_btn').addEventListener('click', (event) => this.showTab(event, 'Fct_tab'), false);
         document.getElementById('Agreg_btn').addEventListener('click', (event) => this.showTab(event, 'Agreg_tab'), false);
         document.getElementById('Multifct_btn').addEventListener('click', (event) => this.showTab(event, 'Multifct_tab'), false);
         document.getElementById("fct1_btn").addEventListener('change', (event) => this.displayFct1(event), false);
         document.getElementById("fct2_btn").addEventListener('change', (event) => this.displayFct2(event), false);
         document.getElementById("fct3_btn").addEventListener('change', (event) => this.displayFct3(event), false);
         document.getElementById("unc1_btn").addEventListener('change', (event) => this.displayUnc1(event), false);
         document.getElementById("unc2_btn").addEventListener('change', (event) => this.displayUnc2(event), false);
         document.getElementById("unc3_btn").addEventListener('change', (event) => this.displayUnc3(event), false);
         // document.getElementById("unc_multif_btn").addEventListener('change', (event) => this.displayUncWeighted(event), false);
         document.getElementById("displayMultif").addEventListener('click', (event) => this.displayMultifctMap(event), false);
         document.getElementById("displayMultifUnc").addEventListener('click', (event) => this.displayUncMultif(event), false);
         document.getElementById("removeMaps").addEventListener('click', (event) => this.cleanMap(event), false);


         this.createLegendFct("legend1", ["#d5efcf", "#9ed798", "#55b567", "#1d8641", "#00441b"]);
         this.createLegendFct("legend2", ["#d1e2f3", "#9ac8e0", "#529dcc", "#1d6cb1", "#08306b"]);
         this.createLegendFct("legend3", ["#fef0d9", "#fdcc8a", "#fc8d59", "#e34a33", "#b30000"]);
         this.createLegendUncFct("legend_unc");
         this.createLegendUncFct("legend_unc2");
         this.createLegendMultif("legend_multif");
         this.createLegendMultif("legend_multif2");
         this.createLegendUncMultif("legend_unc_multif");

         // document.getElementById("ocsge_btn").addEventListener('change', (event) => this.show_OCSGE(event), false);
         document.getElementById("communes_btn").addEventListener('change',
            (event) => this.show_lines(event,
               'communes_src',
               'communes_lyr',
               'communes.zip-je9jr1',
               'mapbox://laco504.37i06i',
               'black',
               3), false);
         document.getElementById("communes_btn2").addEventListener('change',
            (event) => this.show_lines(event,
               'communes_src',
               'communes_lyr',
               'communes.zip-je9jr1',
               'mapbox://laco504.37i06i',
               'black',
               3), false);
         document.getElementById("reseau_hydro_btn").addEventListener('change',
            (event) => this.show_lines(event,
               'hydro_src',
               'hydro_lyr',
               'reseau_hydro.zip-ukbbf7',
               'mapbox://laco504.wb99wt',
               'blue',
               3), false);
         document.getElementById("reseau_hydro_btn2").addEventListener('change',
            (event) => this.show_lines(event,
               'hydro_src',
               'hydro_lyr',
               'reseau_hydro.zip-ukbbf7',
               'mapbox://laco504.wb99wt',
               'blue',
               3), false);
         document.getElementById("reseau_routier_btn").addEventListener('change',
            (event) => this.show_lines(event,
               'routes_src',
               'routes_lyr',
               'reseau_routier.zip-1muvl5',
               'mapbox://laco504.5e7azv',
               'red',
               3), false);
         document.getElementById("reseau_routier_btn2").addEventListener('change',
            (event) => this.show_lines(event,
               'routes_src',
               'routes_lyr',
               'reseau_routier.zip-1muvl5',
               'mapbox://laco504.5e7azv',
               'red',
               3), false);
         document.getElementById("tache_urbaine_btn").addEventListener('change',
            (event) => this.show_polygons(event,
               'tache_urbaine_src',
               'tache_urbaine_lyr',
               'tache_urbaine.zip-qzyy9m',
               'mapbox://laco504.ss210a',
               '#333333',
               3), false);
         document.getElementById("tache_urbaine_btn2").addEventListener('change',
            (event) => this.show_polygons(event,
               'tache_urbaine_src',
               'tache_urbaine_lyr',
               'tache_urbaine.zip-qzyy9m',
               'mapbox://laco504.ss210a',
               '#333333',
               3), false);
         document.getElementById("parcelles_btn").addEventListener('change',
            (event) => this.show_lines(event,
               'parcelles_src',
               'parcelles_lyr',
               'RPG_parcelles.zip-620oi8',
               'mapbox://laco504.95ss46',
               'green',
               3), false);
         document.getElementById("parcelles_btn2").addEventListener('change',
            (event) => this.show_lines(event,
               'parcelles_src',
               'parcelles_lyr',
               'RPG_parcelles.zip-620oi8',
               'mapbox://laco504.95ss46',
               'green',
               3), false);
         
         document.getElementById('runAHP').onclick = this.runAHP;

         // this.testAHP();

      })
   }
}


</script>

<style>
/*.mapboxgl-canvas-container.mapboxgl-interactive,
 .mapboxgl-canvas-container.mapboxgl-interactive:active {
     cursor: none;
     /* cursor: url('@/assets/red.cur'), auto !important; 
 }*/

#mapid {
   height: 100vh;
}

@font-face {
   font-family: sans-serif;
}

.map {
   position: absolute;
   top: 0;
   bottom: 0;
   width: 100%;
}

.rounded {
   width: 30px;
   height: 30px;
   border: 2px solid #fff;
   border-radius: 50%;
}

.map-overlay {
   font: 12px/20px Helvetica;
   position: absolute;
   width: 500px;
   height: 1000px;
   top: 0;
   right: 0;
}

.map-overlay .map-overlay-inner {
   background-color: #fff;
   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
   border-radius: 3px;
   padding: 10px;
   margin-bottom: 10px;
}

.map-overlay-inner fieldset {
   border: none;
   padding: 0;
   margin: 0 0 0px;
}

.map-overlay-inner fieldset:last-child {
   margin: 0;
}

.map-overlay-inner button:focus {
   outline: none;
}

.map-overlay-inner button:hover {
   box-shadow: inset 0 0 0 3px rgba(0, 0, 0, 0.1);
}

/* Style the tab */
.tab {
   overflow: hidden;
   border: 1px solid #f1f1f1;
   background-color: #dddddd;
}

/* Style the buttons that are used to open the tab content */
.tab button {
   background-color: inherit;
   float: left;
   border: none;
   outline: none;
   cursor: pointer;
   width: 320 px;
   padding: 10px 25px;
   transition: 0.3s;
}

/* Change background color of buttons on hover */
.tab button:hover {
   background-color: #cccccc;
}

/* Create an active/current tablink class */
.tab button.active {
   background-color: #D2EAF1;
}

/* Style the tab content */
.tabcontent {
   display: none;
   padding: 10px 10px;
   border: 1px solid #ccc;
   border-top: none;
}

input[type=checkbox] {
   vertical-align: middle;
   position: relative;
   bottom: 1px;
}

input[type="radio"] {
   height: 10px;
   line-height: 10px;
   vertical-align: bottom;
   width: 30px;
}

label {
   display: inline;
   /* font-size: 20px;
  line-height: 30px;
  margin: 0 auto; */
   width: 100%;
}

.legend-key {
   display: inline-block;
   width: 12px;
   height: 12px;
   margin-right: 6px;
}

.range-input {
   -webkit-appearance: none;
   appearance: none;
   width: 50%;
   object-position: 25px 25px;
   cursor: pointer;
   outline: none;
   border-radius: 15px;
   height: 6px;
   background: #ccc;
}

.range-input::-webkit-slider-thumb {
   -webkit-appearance: none;
   appearance: none;
   height: 15px;
   width: 15px;
   object-position: 20% 70%;
   background-color: #FDD365;
   border-radius: 50%;
   border: none;
   transition: .2s ease-in-out;
}

.range-input::-moz-range-thumb {
   height: 15px;
   width: 15px;
   object-position: 20% 70%;
   background-color: #FDD365;
   border-radius: 50%;
   border: none;
   transition: .2s ease-in-out;
}

.range-input::-webkit-slider-thumb:hover {
   box-shadow: 0 0 0 10px rgba(255, 85, 0, .1)
}

.range-input:active::-webkit-slider-thumb {
   box-shadow: 0 0 0 13px rgba(255, 85, 0, .2)
}

.range-input:focus::-webkit-slider-thumb {
   box-shadow: 0 0 0 13px rgba(255, 85, 0, .2)
}

.range-input::-moz-range-thumb:hover {
   box-shadow: 0 0 0 10px rgba(255, 85, 0, .1)
}

.range-input:active::-moz-range-thumb {
   box-shadow: 0 0 0 13px rgba(255, 85, 0, .2)
}

.range-input:focus::-moz-range-thumb {
   box-shadow: 0 0 0 13px rgba(255, 85, 0, .2)
}

hr {
   border: none;
   height: 3px;
   /* Set the hr color */
   color: #e6e6e6;
   /* old IE */
   background-color: #e6e6e6;
   /* Modern Browsers */
}

</style>